/* Pehchaan — theme.js
 * Lightweight interactions: cart drawer, product form, variant selection, filters.
 */

(function () {
  'use strict';

  /* -------- Cart drawer -------- */
  const drawer = document.getElementById('CartDrawer');
  function openCart() { if (drawer) drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (drawer) drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }

  document.addEventListener('click', function (e) {
    const openEl = e.target.closest('[data-cart-open]');
    const closeEl = e.target.closest('[data-cart-close]');
    if (openEl) { e.preventDefault(); openCart(); refreshCart(); }
    if (closeEl) { e.preventDefault(); closeCart(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  async function refreshCart() {
    const body = document.querySelector('[data-cart-body]');
    if (!body) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart, body);
    } catch (err) {
      console.error('Cart fetch failed', err);
    }
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart, body) {
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.<br><br><a href="/collections/all" class="btn btn--outline">Start Shopping</a></p>';
      return;
    }
    const items = cart.items.map(function (item) {
      return '\
      <article class="cart-item">\
        <a href="' + item.url + '"><img src="' + (item.image || '') + '" alt="' + item.title + '" width="80"></a>\
        <div class="cart-item__body">\
          <h4>' + item.product_title + '</h4>\
          <span class="cart-item__variant">' + (item.variant_title || '') + '</span>\
          <div class="cart-item__meta">\
            <span>Qty ' + item.quantity + '</span>\
            <span>' + money(item.final_line_price) + '</span>\
          </div>\
        </div>\
      </article>';
    }).join('');

    body.innerHTML = items +
      '<div class="cart-drawer__footer">\
        <div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>\
        <a href="/checkout" class="btn btn--primary" style="width:100%;justify-content:center;">Checkout</a>\
        <a href="/cart" class="btn btn--ghost" style="margin-top:12px;display:block;text-align:center;">View full cart</a>\
      </div>';
  }

  /* -------- Product form: variants + add to cart -------- */
  const productForms = document.querySelectorAll('[data-product-form]');
  productForms.forEach(function (form) {
    const dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    let product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const optionInputs = form.querySelectorAll('[data-option]');
    const variantIdInput = form.querySelector('[name="id"]');
    const priceEl = form.querySelector('[data-product-price]');
    const submitBtn = form.querySelector('[data-atc-btn]');

    function selectedOptions() {
      const opts = {};
      optionInputs.forEach(function (el) {
        if (el.dataset.selected === 'true') opts[el.dataset.option] = el.dataset.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return (product.variants || []).find(function (v) {
        return v.options.every(function (optVal, i) {
          return opts['option' + (i + 1)] === optVal;
        });
      });
    }

    function updateUI() {
      const opts = selectedOptions();
      const variant = findVariant(opts);
      if (!variant) {
        if (submitBtn) { submitBtn.textContent = 'Unavailable'; submitBtn.disabled = true; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = money(variant.price) +
        (variant.compare_at_price && variant.compare_at_price > variant.price
          ? ' <del>' + money(variant.compare_at_price) + '</del>'
          : '');
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to Cart — Pehchaan' : 'Sold Out';
      }
    }

    optionInputs.forEach(function (el) {
      el.addEventListener('click', function () {
        const group = el.dataset.option;
        form.querySelectorAll('[data-option="' + group + '"]').forEach(function (sib) {
          sib.dataset.selected = 'false';
          sib.classList.remove('is-selected');
        });
        el.dataset.selected = 'true';
        el.classList.add('is-selected');
        updateUI();
      });
    });

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res.ok) throw new Error('Add failed');
        openCart();
        refreshCart();
      } catch (err) {
        console.error(err);
        window.location = '/cart';
      }
    });

    updateUI();
  });

  /* -------- Collection filters (client-side reveal/hide) -------- */
  const filterBtns = document.querySelectorAll('[data-filter]');
  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const tag = btn.dataset.filter;
      document.querySelectorAll('[data-filter]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      document.querySelectorAll('[data-product-card]').forEach(function (card) {
        const tags = (card.dataset.tags || '').split(',');
        card.style.display = (tag === 'all' || tags.indexOf(tag) !== -1) ? '' : 'none';
      });
    });
  });

  /* -------- Scroll reveal -------- */
  const io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 }) : null;

  document.querySelectorAll('[data-reveal]').forEach(function (el) {
    if (io) io.observe(el); else el.classList.add('is-visible');
  });

})();
